/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tooltip/dist/react-tooltip.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-tabs/style/react-tabs.css';
import 'react-toastify/dist/ReactToastify.css';
import './css/style.css'
import './css/animations.css'
import './Effects.scss'
import React from 'react';
import ReactDOM from 'react-dom/client';
import Portal from './layouts/Portal';
import E404 from './components/E404';
import Login from './components/Login';
import Logout from './components/Logout';
import SetPassword from './components/SetPassword';
import { Route, createBrowserRouter, RouterProvider, createRoutesFromElements } from "react-router-dom";
import Dashboard from './components/Dashboard';
import EConnection from './components/EConnection';
import Outside from './layouts/Outside';
import Orders from './components/Orders'
import BaseComponent from './components/BaseCom';
import Users from './components/Users';
import UsersEdit from './components/UsersEdit';
import OrderNew from './components/OrderNew';
import OrderView from './components/OrderView';
import Accounts from './components/Accounts';
import Patients from './components/Patients';
import ScheduleView from './components/ScheduleView';
import Globals from './shared/Globals';
import VisitView from './components/VisitView';
import DocumentRequests from './components/DocumentRequests';
import Providers from './components/Providers';
import ProviderView from './components/ProviderView';
import Products from './components/Products';
import ProductView from './components/ProductView';
import Invoices from './components/Invoices';
import InvoiceView from './components/InvoiceView';
import PurchaseOrders from './components/PurchaseOrders';
import PurchaseOrderView from './components/PurchaseOrderView';
import Facilities from './components/Facilities';
import MarketingPartners from './components/MarketingPartners';
import ExaminationList from './components/ExaminationList';
import ExaminationPatient from './components/ExaminationPatient';
import OrganizationList from './components/OrganizationList';
import OrganizationView from './components/OrganizationView';
import SearchResults from './components/SearchResults';
import MedicalProcedures from './components/MedicalProcedures';
import MedicalProcedureView from './components/MedicalProcedureView';
import Leads from './components/Leads';
import LeadsEdit from './components/LeadsEdit';
import Auth from './shared/Auth';
import { Pop } from './components/PopModal';
import Calendar from './components/Calendar';
import SurveyAdmin from './components/survey/SurveyAdmin';
import SurveyAdminEdit from './components/survey/SurveyAdminEdit';
import SurveySubmissions from './components/survey/SurveySubmissions';
import Storage from './components/storage/Storage';
import Administration from './components/_Administration';
import Contacts from './components/Contacts';
import ContactView from './components/ContactView';
import Groups from './components/Groups';
import GroupView from './components/GroupView';
import Home from './components/Home';
import IVRSign from './components/IVRSign';
import Menu from './components/_Menu';
import MedicalReleaseRequest from './components/MedicalReleaseRequest';
import RequestFormList from './components/requestform/RequestFormList';
import RequestFormEdit from './components/requestform/RequestFormEdit';
import Reports from './components/reports/Reports';
import ReportViewer from './components/reports/ReportViewer';
import NextActions from './components/manage/NextActions';
import ChatChannel from './components/chat/ChatChannel';
import WoundDB from './components/WoundDB';
import MyDay from './components/MyDay';
import Redirect from './components/Redirect';
import Settings from './components/Settings';
import RequestFormTypeList from './components/requestform/RequestFormTypeList';
import RequestFormFill from './components/requestform/RequestFormFill';
import DocumentCategories from './components/manage/DocumentCategories';
import PracticeList from './components/PracticeList';
import PracticeView from './components/PracticeView';
import ChatEditChannel from './components/chat/ChatEditChannel';
import ChatChannelInfo from './components/chat/ChatChannelInfo';
import SpecimenList from './components/lab/SpecimenList';
import SpecimenEdit from './components/lab/SpecimenEdit';
import PanelManageList from './components/lab/PanelManageList';
import PanelManageEdit from './components/lab/PanelManageEdit';
import ProductLineList from './components/lab/ProductLineList';
import ProductLineEdit from './components/lab/ProductLineEdit';
import PanelTargetManageList from './components/lab/PanelTargetManageList';
import PanelTargetManageEdit from './components/lab/PanelTargetManageEdit';
import SpecimenTypeList from './components/lab/SpecimenTypeList';
import SpecimenTypeEdit from './components/lab/SpecimenTypeEdit';
import LabManager from './components/lab/LabManager';
import ClaimList from './components/billing/ClaimList';
import ManufacturerList from './components/inventory/ManufacturerList';
import ManufacturerView from './components/inventory/ManufacturerView';
import Inventory from './components/inventory/Inventory';
import InventoryItem from './components/inventory/InventoryItem';
import ResultsReview from './components/lab/ResultsReview';
import ReportTemplateList from './components/lab/ReportTemplateList';
import ReportTemplateEdit from './components/lab/ReportTemplateEdit';
import ClaimNew from './components/billing/ClaimNew';
import ClaimEdit from './components/billing/ClaimEdit';
import RuleManagerList from './components/lab/rule/RuleManagerList';
import RuleManagerEdit from './components/lab/rule/RuleManagerEdit';
import ScanInventory from './components/inventory/ScanInventory';
import AssetLibrary from './components/resources/AssetLibrary';
import RoleList from './components/role/RoleList';
import RoleEdit from './components/role/RoleEdit';
import AccountEdit from './components/account/AccountEdit';
import LabLocationList from './components/lab/location/LabLocationList';
import LabLocationEdit from './components/lab/location/LabLocationEdit';
import PackageSlip from './components/inventory/PackageSlip';
import Checkout from './components/payment/Checkout';
import InStock from './components/inventory/InStock';
import AccountView from './components/account/AccountView';
import ScanQueue from './components/inventory/ScanQueue';
import Floor from './components/ehr/Floor';
import WorkflowList from './components/workflow/WorkflowList';
import WorkflowEdit from './components/workflow/WorkflowEdit';
import PaymentRequest from './components/payment/PaymentRequest';
import PaymentTransactions from './components/PaymentTransactions';
import ProjectList from './components/project/ProjectList';
import ProjectView from './components/project/ProjectView';
import WorkorderList from './components/project/WorkorderList';
import WorkorderEdit from './components/project/WorkorderEdit';
import WorkorderNew from './components/project/WorkorderNew';
import WorkorderView from './components/project/WorkorderView';
import ResultsReviewUtility from './components/lab/ResultsReviewUtility';
import ForgotPassword from './components/ForgotPassword';
import SharedUtil from './shared/SharedUtil';
import AuditLogList from './components/AuditLogList';
import Quotes from './components/Quotes';
import QuoteView from './components/QuoteView';
import QuoteSignRequest from './components/QuoteSignRequest';
import MyMenu from './components/my/MyMenu';
import MyInfo from './components/my/MyInfo';
import InstanceList from './components/_mst/InstanceList';
import InventoryBoxList from './components/inventory/InventoryBoxList';
import InstanceView from './components/_mst/InstanceView';
import Shop from './components/Shop';
import { loadLang, pullCurrentLang } from './shared/GLang';
import L from './components/Lang';
import ClientLanding from './client/ClientLanding';
import ClientLayout from './layouts/ClientLayout';
import ClientOnboarding from './client/ClientOnboarding';
import ClientLogin from './client/ClientLogin';
import ClientShop from './client/ClientShop';
import ClientAppointment from './client/ClientAppointment';
import UDHSOnboarding from './_MST/UDHSOnboarding';
import DataManager from './components/manage/DataManager';
import DataManagerList from './components/manage/DataManagerList';
import DataManagerEdit from './components/manage/DataManagerEdit';
import ShopCategory from './components/ShopCategory';
import UserView from './components/UserView';
import CallList from './components/CallList';
import DocumentAnalyzeUpload from './components/DocumentAnalyzeUpload';

var router = null;

export const AppGlobal = {
    setLang() { },
    getCurrentLang() { }
};

class AppRouter extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            loaded: false,
            connected: false
        };
        this.interval = null;
        this.tick = this.tick.bind(this);
        this.isConnected = this.isConnected.bind(this);
        this.setUser = this.setUser.bind(this);
    }

    async componentDidMount() {
        await this.getMainOrg();
        this.loadLang();
        this.tickInProcess = false;
        this.tick();
        if (!this.interval)
            this.interval = setInterval(this.tick, 10000);
        this.author();
        this.supervisor = setInterval(this.supervisor, 100);
    }

    loadLang = () => {
        AppGlobal.setLang = this.setLang;
        AppGlobal.getCurrentLang = () => {
            return this.state.lang;
        };
        loadLang(() => {
            pullCurrentLang(lang => {
                this.setState({ lang: lang });
            });
        });
    }

    setLang = (lang) => {
        Globals.setLang(lang);
        this.setState({ lang: lang });
        this.forceUpdate();
    }

    getMainOrg = async (errorCallback) => {
        let org = await SharedUtil.getMainOrgAsync();
        if (org) {
            this.setState({ org: org });
            return org;
        }
        else {
            if (errorCallback)
                errorCallback();
            else
                console.error('Failed to get main org.');
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        clearInterval(this.supervisor);
    }

    isConnected() {
        return this.state.connected;
    }

    setUser(user) {
        Globals.set('user', user);
        Globals.set('sid', user.sid);
        this.setState({ user: user });
    }

    tick() {
        if (this.tickInProcess)
            return;
        this.tickInProcess = true;
        Auth.getLogin(user => {
            if (this.state.showConnError) {
                clearInterval(this.interval);
                this.interval = setInterval(this.tick, 10000);
            }
            this.setState({ showConnError: false });
            var neutp = Globals.getNeutralPath(document.location.pathname);
            if (neutp) {
                this.setState({ user: user, loaded: true });
                return;
            }
            var pn = Globals.getOutsidePath(document.location.pathname);
            if (user) {
                var prevVersion = 0;
                if (this.state.user)
                    prevVersion = this.state.user.version;
                this.setState({ user: user });
                if (pn !== null) {
                    if (pn === '/user-invite')
                        alert('User invites can only be accepted when you are not logged in.');
                    document.location.replace('/dashboard');
                    return;
                }
                if (user.version && prevVersion !== 0 && user.version !== prevVersion) {
                    Pop.showConfirm(<><L>The portal version has changed from</L> <b>{prevVersion}</b> <L>to</L> <b>{user.version}</b> <L>. Please</L> <i><L>Confirm</L></i> <L>to refresh and view the newest version. If you still have unsaved data. Please click</L> <i><L>Cancel</L></i> <L>and save your data first, then refresh the browser.</L></>, 'New Version', () => {
                        window.location.reload(true);
                    });
                }
            }
            else {
                if (pn === null) {
                    document.location.replace('/login/' + encodeURIComponent(btoa(document.location.pathname)));
                    return;
                }
            }
            this.setState({ connected: true });
            if (!this.state.loaded)
                this.setState({ loaded: true });
            this.tickInProcess = false;
        }, () => {
            this.tickInProcess = false;
            this.setState({ loaded: true, connected: false, showConnError: true });
            clearInterval(this.interval);
            this.interval = setInterval(this.tick, 5000);
        }, true);
    }

    supervisor = () => {
        let h1 = document.querySelector('h1');
        if (h1) {
            document.title = h1.innerText + (this.state.org ? ' - ' + this.state.org.name : '');
        }
    }

    render() {
        if (!this.state.loaded)
            return <></>;

        router = createBrowserRouter(createRoutesFromElements(
            <>
                <Route path="/" element={this.state.user ? <Portal user={this.state.user} showConnError={this.state.showConnError} /> : <Outside />}>
                    <Route index element={<Home />} />

                    <Route path="menu" element={<Menu />} />

                    <Route path="dashboard" element={<Dashboard />} />

                    <Route path="calendar" element={<Calendar user={this.state.user} />} />

                    <Route path="myday" element={<MyDay />} />

                    <Route path="order" element={<Orders init />} />
                    <Route path="order/discharge" element={<Orders type="discharge" />} />
                    <Route path="order/discharge/list/page/:page" element={<Orders type="discharge" />} />
                    <Route path="order/list" element={<Orders />} />
                    <Route path="order/list/page/:page" element={<Orders />} />
                    <Route path="order/list/documents/:id" element={<Orders showUploadModal />} />
                    <Route path="order/filter/:filter" element={<Orders />} />
                    <Route path="order/new" element={<OrderNew />} />
                    <Route path="order/view/:id" element={<OrderView />} />
                    <Route path="order/view/:id/:tab" element={<OrderView />} />
                    <Route path="order/edit/:id" element={<OrderView edit={true} />} />
                    <Route path="order/edit/:id/:tab" element={<OrderView edit={true} />} />

                    <Route path="floor" element={<Floor />} />

                    <Route path="search/:query" element={<SearchResults />} />

                    <Route path="lead" element={<Redirect to="/lead/inbound" />} />
                    <Route path="lead/:bucket" element={<Leads />} />
                    <Route path="lead/:bucket/page/:page" element={<Leads />} />
                    <Route path="lead/list" element={<Leads />} />
                    <Route path="lead/list/page/:page" element={<Leads />} />
                    <Route path="lead/new" element={<LeadsEdit />} />
                    <Route path="lead/edit/:id" element={<LeadsEdit />} />

                    <Route path="manager" element={<Administration />} />
                    <Route path="medical-group" element={<Administration />} />

                    <Route path="account" element={<Accounts />} />
                    <Route path="account/list" element={<Accounts />} />
                    <Route path="account/list/page/:page" element={<Accounts />} />
                    <Route path="account/new" element={<AccountEdit edit />} />
                    <Route path="account/edit/:id" element={<AccountEdit edit />} />
                    <Route path="account/:id" element={<AccountView />} />
                    <Route path="account/:id/edit" element={<AccountEdit edit />} />

                    <Route path="facility" element={<Facilities />} />
                    <Route path="facility/list" element={<Facilities />} />
                    <Route path="facility/list/page/:page" element={<Facilities />} />
                    <Route path="facility/new" element={<AccountView edit={true} facility />} />
                    <Route path="facility/edit/:id" element={<AccountView edit={true} facility />} />
                    <Route path="facility/view/:accountID/examination/list" element={<ExaminationList />} />

                    <Route path="marketing-partner" element={<MarketingPartners />} />
                    <Route path="marketing-partner/list" element={<MarketingPartners />} />
                    <Route path="marketing-partner/list/page/:page" element={<MarketingPartners />} />
                    <Route path="marketing-partner/new" element={<AccountView edit={true} marketingPartner />} />
                    <Route path="marketing-partner/edit/:id" element={<AccountView edit={true} marketingPartner />} />

                    <Route path="examination" element={<ExaminationList />} />
                    <Route path="examination/list" element={<ExaminationList />} />
                    <Route path="examination/list/page/:page" element={<ExaminationList />} />
                    <Route path="examination/new" element={<ExaminationPatient edit={true} />} />
                    <Route path="examination/view/:patientID" element={<ExaminationPatient edit={true} />} />
                    <Route path="examination/view/:patientID/:examinationID" element={<ExaminationPatient edit={true} />} />
                    <Route path="examination/view/:patientID/:examinationID/:tab" element={<ExaminationPatient edit={true} />} />

                    <Route path="organization" element={<OrganizationList />} />
                    <Route path="organization/list" element={<OrganizationList />} />
                    <Route path="organization/list/page/:page" element={<OrganizationList />} />
                    <Route path="organization/new" element={<OrganizationView edit={true} />} />
                    <Route path="organization/edit/:id" element={<OrganizationView edit={true} />} />

                    <Route path="practice" element={<PracticeList />} />
                    <Route path="practice/list" element={<PracticeList />} />
                    <Route path="practice/list/page/:page" element={<PracticeList />} />
                    <Route path="practice/new" element={<PracticeView edit={true} />} />
                    <Route path="practice/edit/:id" element={<PracticeView edit={true} />} />

                    <Route path="medical-procedure" element={<MedicalProcedures />} />
                    <Route path="medical-procedure/list" element={<MedicalProcedures />} />
                    <Route path="medical-procedure/list/page/:page" element={<MedicalProcedures />} />
                    <Route path="medical-procedure/new" element={<MedicalProcedureView edit={true} />} />
                    <Route path="medical-procedure/edit/:id" element={<MedicalProcedureView edit={true} />} />


                    <Route path="patient" element={<Patients />} />
                    <Route path="patient/list" element={<Patients />} />
                    <Route path="patient/list/page/:page" element={<Patients />} />


                    <Route path="provider" element={<Providers />} />
                    <Route path="provider/list" element={<Providers />} />
                    <Route path="provider/list/page/:page" element={<Providers />} />
                    <Route path="provider/new" element={<ProviderView />} />
                    <Route path="provider/edit/:id" element={<ProviderView />} />

                    <Route path="contact" element={<Contacts />} />
                    <Route path="contact/list" element={<Contacts />} />
                    <Route path="contact/list/page/:page" element={<Contacts />} />
                    <Route path="contact/new" element={<ContactView />} />
                    <Route path="contact/edit/:id" element={<ContactView />} />

                    <Route path="group" element={<Groups />} />
                    <Route path="group/list" element={<Groups />} />
                    <Route path="group/list/page/:page" element={<Groups />} />
                    <Route path="group/new" element={<GroupView />} />
                    <Route path="group/edit/:id" element={<GroupView />} />

                    <Route path="product" element={<Products />} />
                    <Route path="product/list" element={<Products />} />
                    <Route path="product/list/page/:page" element={<Products />} />
                    <Route path="product/list/:tab" element={<Products />} />
                    <Route path="product/list/:tab/page/:page" element={<Products />} />
                    <Route path="product/new" element={<ProductView />} />
                    <Route path="product/new/:tab" element={<ProductView />} />
                    <Route path="product/edit/:id" element={<ProductView />} />


                    {/* Call */}
                    <Route path="call" element={<CallList />} />

                    {/* Document Analyze */}
                    <Route path="document/analyze/upload" element={<DocumentAnalyzeUpload />} />

                    {/* Invoice */}

                    <Route path="invoice" element={<Invoices />} />
                    <Route path="invoice/list" element={<Invoices />} />
                    <Route path="invoice/list/page/:page" element={<Invoices />} />
                    <Route path="invoice/new" element={<InvoiceView />} />
                    <Route path="invoice/edit/:id" element={<InvoiceView />} />

                    {/* Quote */}

                    <Route path="quote" element={<Quotes />} />
                    <Route path="quote/list" element={<Quotes />} />
                    <Route path="quote/list/page/:page" element={<Quotes />} />
                    <Route path="quote/new" element={<QuoteView />} />
                    <Route path="quote/edit/:id" element={<QuoteView />} />
                    <Route path="quote/sign-request/:uniqueIdent" element={<QuoteSignRequest />} />

                    {/* Payment */}

                    <Route path="payment-transaction" element={<PaymentTransactions />} />
                    <Route path="payment-transaction/list" element={<PaymentTransactions />} />
                    <Route path="payment-transaction/list/page/:page" element={<PaymentTransactions />} />

                    <Route path="purchase-order" element={<PurchaseOrders />} />
                    <Route path="purchase-order/list" element={<PurchaseOrders />} />
                    <Route path="purchase-order/list/page/:page" element={<PurchaseOrders />} />
                    <Route path="purchase-order/new" element={<PurchaseOrderView />} />
                    <Route path="purchase-order/edit/:id" element={<PurchaseOrderView />} />

                    <Route path="purchase-order/:poID/checkout" element={<Checkout purchaseOrder />} />

                    <Route path="package-slip/po/:poID" element={<PackageSlip />} />

                    <Route path="schedule/new" element={<ScheduleView edit={true} />} />
                    <Route path="schedule/new/event" element={<ScheduleView edit={true} event />} />
                    <Route path="schedule/new/patient/:patientID" element={<ScheduleView patientSelect />} />
                    <Route path="visit/view/:id" element={<VisitView />} />
                    <Route path="visit/view/:id/:tab" element={<VisitView />} />
                    <Route path="document/request/list" element={<DocumentRequests />} />

                    <Route path="document/ivr/:orderID/sign" element={<IVRSign />} />
                    <Route path="document/ivr/:orderID/view" element={<IVRSign />} />

                    <Route path="user" element={<Users />} />
                    <Route path="user/list" element={<Users />} />
                    <Route path="user/new" element={<UsersEdit />} />
                    <Route path="user/edit/:id" element={<UsersEdit />} />
                    <Route path="user/:tab" element={<Users />} />

                    <Route path="role" element={<RoleList />} />
                    <Route path="role/list" element={<RoleList />} />
                    <Route path="role/new" element={<RoleEdit />} />
                    <Route path="role/edit/:id" element={<RoleEdit />} />

                    <Route path="survey" element={<SurveyAdmin />} />
                    <Route path="survey/list" element={<SurveyAdmin />} />
                    <Route path="survey/list/page/:page" element={<SurveyAdmin />} />
                    <Route path="survey/edit/:id" element={<SurveyAdminEdit />} />
                    <Route path="survey/new" element={<SurveyAdminEdit />} />
                    <Route path="survey/:surveyID/submission" element={<SurveySubmissions />} />

                    <Route path="form" element={<RequestFormList />} />
                    <Route path="form/type/list" element={<RequestFormTypeList />} />
                    <Route path="form/type/new" element={<RequestFormEdit />} />
                    <Route path="form/type/edit/:id" element={<RequestFormEdit />} />
                    <Route path="form/list" element={<RequestFormList />} />
                    <Route path="form/list/page/:page" element={<RequestFormList />} />
                    <Route path="form/new" element={<RequestFormEdit />} />
                    <Route path="form/edit/:id" element={<RequestFormEdit />} />
                    <Route path="form/request/:uniqueIdent" element={<RequestFormFill />} />
                    <Route path="form/request/:uniqueIdent/inline" element={<RequestFormFill inline />} />

                    <Route path="reports" element={<Reports />} />
                    <Route path="reports/:ident" element={<ReportViewer />} />

                    <Route path="manage/next-action/" element={<NextActions />} />
                    <Route path="manage/document-category/" element={<DocumentCategories />} />

                    <Route path="chat/new/:orderID" element={<ChatChannel />} />
                    <Route path="chat/:id" element={<ChatChannel />} />
                    <Route path="chat/:id/info" element={<ChatChannelInfo />} />
                    <Route path="chat/:id/edit" element={<ChatEditChannel />} />
                    <Route path="chat/channel/new" element={<ChatEditChannel />} />

                    <Route path="lab/manager" element={<LabManager />} />

                    <Route path="specimen/list" element={<SpecimenList />} />
                    <Route path="specimen/:id/edit" element={<SpecimenEdit edit />} />
                    <Route path="specimen/new" element={<SpecimenEdit edit />} />
                    <Route path="specimen/:id" element={<SpecimenEdit />} />

                    <Route path="panel/manage/list" element={<PanelManageList />} />
                    <Route path="panel/manage/new" element={<PanelManageEdit />} />
                    <Route path="panel/manage/:id" element={<PanelManageEdit />} />

                    <Route path="target/manage/list" element={<PanelTargetManageList />} />
                    <Route path="target/manage/new" element={<PanelTargetManageEdit />} />
                    <Route path="target/manage/:id" element={<PanelTargetManageEdit />} />

                    <Route path="productline/list" element={<ProductLineList />} />
                    <Route path="productline/new" element={<ProductLineEdit />} />
                    <Route path="productline/:id" element={<ProductLineEdit />} />

                    <Route path="specimentype/list" element={<SpecimenTypeList />} />
                    <Route path="specimentype/new" element={<SpecimenTypeEdit />} />
                    <Route path="specimentype/:id" element={<SpecimenTypeEdit />} />

                    <Route path="lab/location" element={<LabLocationList />} />
                    <Route path="lab/location/list" element={<LabLocationList />} />
                    <Route path="lab/location/new" element={<LabLocationEdit />} />
                    <Route path="lab/location/:id" element={<LabLocationEdit />} />

                    <Route path="rule/list" element={<RuleManagerList />} />
                    <Route path="rule/new" element={<RuleManagerEdit />} />
                    <Route path="rule/:id" element={<RuleManagerEdit />} />

                    <Route path="results/review" element={<ResultsReview />} />
                    <Route path="results/review/utility" element={<ResultsReviewUtility />} />

                    <Route path="report-template/list" element={<ReportTemplateList />} />
                    <Route path="report-template/new" element={<ReportTemplateEdit />} />
                    <Route path="report-template/:id" element={<ReportTemplateEdit />} />

                    <Route path="claim/list" element={<ClaimList />} />
                    <Route path="claim/new" element={<ClaimNew />} />
                    <Route path="claim/:id" element={<ClaimEdit />} />

                    <Route path="manufacturer/list" element={<ManufacturerList />} />
                    <Route path="manufacturer/new" element={<ManufacturerView />} />
                    <Route path="manufacturer/:id" element={<ManufacturerView />} />

                    {/* INVENTORY */}
                    <Route path="inventory" element={<Inventory />} />
                    <Route path="inventory/new" element={<InventoryItem />} />
                    <Route path="inventory/instock" element={<InStock />} />
                    <Route path="inventory/:id" element={<InventoryItem />} />
                    <Route path="inventory/box" element={<InventoryBoxList />} />

                    <Route path="scan/in" element={<ScanInventory in />} />
                    <Route path="scan/out" element={<ScanQueue />} />
                    <Route path="scan/out/legacy" element={<ScanInventory out />} />


                    <Route path="workflow" element={<WorkflowList />} />
                    <Route path="workflow/new" element={<WorkflowEdit />} />
                    <Route path="workflow/:id" element={<WorkflowEdit />} />


                    <Route path="asset-library" element={<AssetLibrary />} />
                    <Route path="asset-library/:parentID" element={<AssetLibrary />} />


                    {/*<Route path="tool/orders-reps" element={<OrdersReps />} />*/}

                    <Route path="settings" element={<Settings />} />


                    <Route path="wound/db" element={<WoundDB />} />
                    <Route path="storage" element={<Storage />} />

                    <Route path="medical-release/request/:uniqueIdent" element={<MedicalReleaseRequest />} />

                    {/* SHOP */}
                    <Route path="shop" element={<Shop />} />

                    {/* CATEGORIES */}
                    <Route path="shop/category" element={<ShopCategory />} />
                    <Route path="shop/category/:categoryID" element={<Shop />} />

                    {/* PAYMENT REQUEST */}
                    <Route path="payment-request/:code" element={<PaymentRequest />} />

                    {/* PROJECT */}
                    <Route path="project" element={<ProjectList />} />
                    <Route path="project/new" element={<ProjectView />} />
                    <Route path="project/:id" element={<ProjectView />} />
                    <Route path="workorder" element={<WorkorderList />} />
                    <Route path="workorder/page/:page" element={<WorkorderList />} />
                    <Route path="workorder/new" element={Auth.hasRole('task-requester') ? <WorkorderNew /> : <WorkorderEdit />} />
                    <Route path="workorder/:id" element={<WorkorderView />} />
                    <Route path="workorder/:id/edit" element={<WorkorderEdit />} />

                    {/* AUDIT LOG */}
                    <Route path="auditlog" element={<AuditLogList />} />

                    {/* USER */}
                    <Route path="my" element={<MyMenu />} />
                    <Route path="my/info" element={<MyInfo />} />
                    <Route path="my/security" element={<MyMenu />} />


                    {/* DATA MANAGER */}
                    <Route path="data">
                        <Route index element={<DataManager />} />
                        <Route path=":model" element={<DataManagerList />} />
                        <Route path=":model/new" element={<DataManagerEdit new />} />
                        <Route path=":model/:id" element={<DataManagerEdit />} />
                    </Route>


                    {/* USER PROFILE */}
                    <Route path="user-profile/:id" element={<UserView />} />

                    {/* MASTER */}
                    <Route path="instance" element={<InstanceList />} />
                    <Route path="instance/:id" element={<InstanceView />} />


                    <Route path="login" element={<Login />} />
                    <Route path="login/:follow" element={<Login />} />
                    <Route path="logout" element={<Logout />} />
                    <Route path="user-invite/:code" element={<SetPassword setUser={this.setUser} />} />
                    <Route path="set-password/:code" element={<SetPassword setUser={this.setUser} />} />
                    <Route path="forgot-password" element={<ForgotPassword />} />

                    <Route path="error/connection" element={<EConnection isConnectedCallback={this.isConnected} />} />
                    <Route path="error/connection/:ref" element={<EConnection isConnectedCallback={this.isConnected} />} />


                    <Route path="*" element={<E404 />} />
                </Route>

                <Route path="/client" element={<ClientLayout />}>
                    <Route index element={<ClientLanding />} />
                    <Route path="login" element={<ClientLogin />} />
                    <Route path="signup" element={<ClientOnboarding />} />
                    <Route path="forgot-password" element={<ForgotPassword client />} />

                    {/* SHOP */}
                    <Route path="shop" element={<ClientShop />} />

                    {/* APPOINTMENT */}
                    <Route path="appointment" element={<ClientAppointment />} />

                    <Route path="*" element={<E404 />} />
                </Route>

                <Route path="/onboarding" element={<UDHSOnboarding />} />
            </>
        ));
        return <RouterProvider router={router} />;
    }
}

const root = document.getElementById('root');

if (!root._reactRoot) {
    root._reactRoot = ReactDOM.createRoot(root);
}
root._reactRoot.render(
    <AppRouter />
);


